import styled from "styled-components";

export const CoursesGrid = styled.div`
  display: grid;
  gap: 8px;

  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const CoursesItem = styled.div`
  border: 1px solid #eee;
  border-radius: 10px;
  background-color: #fdf9f0;
  padding: 1.5rem 1rem;
  display: flex;
  flex-direction: column;

  & > img {
    border-radius: 10px;
    width: 100%;
    height: 135px;
    object-fit: cover;
  }

  & > h1,
  p {
    color: #333;
  }

  & > h1 {
    font-family: "Bricolage Grotesque", sans-serif;
    font-size: 17px;
    margin-top: 1.25rem;
    font-weight: 800;
  }

  & > p {
    font-size: 14px;
    margin-top: 12px;
  }
`;

export const BottomCourse = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;

  & > h1 {
    font-size: 13px;
    color: #333;
    font-weight: 800;

    & > span {
      font-weight: 500;
    }
  }
`;

export const JoinButton = styled.button`
  border-radius: 10px;
  background: #333;
  color: #fff;
  outline: none;
  border: 0;
  font-size: 12px;
  padding: 4px 14px;
  cursor: pointer;
`;
